import styles from './Template.module.scss'
import ServicesFV from 'components/services/common/ServicesFV'
import Problem from 'components/services/common/Problem'
import Feature2 from 'components/services/common/Feature2'
import type { FeatureItem2 } from 'components/services/common/Feature2/Feature2'
import StepIcon from 'components/services/common/StepModernization'
import type { StepModernizationItem } from 'components/services/common/StepModernization'
import Faq from 'components/services/common/Faq'
import { modernizationFaqList } from 'components/common/schema/data/faqs/modernization'
import RelatedPosts from 'components/services/common/RelatedPosts'
import type { RelatedPostsItem } from 'components/services/common/RelatedPosts/RelatedPosts'
import FooterCTA from 'components/common/FooterCTA'

const paths = [
  { name: 'TOP', url: '/' },
  { name: 'Services', url: '#' },
  { name: 'モダナイゼーション', url: '#' },
]

const ServicesFVList = {
  category: 'モダンアプリケーション開発',
  title: (
    <>
      <span>モ</span>
      <span>ダ</span>
      <span>ナ</span>
      <span>イ</span>
      <span>ゼ</span>
      <span>ー</span>
      <span>シ</span>
      <span>ョ</span>
      <span>ン</span>
    </>
  ),
  text: '生成AIで既存システムを再生し、モダナイゼーションを加速します。担当者が不在でも安心して進められるよう、ソースコードの解析からドキュメント化、改修、E2Eテストまでをトータルで支援します。',
  imgSrc: '/img/services/services_fv_modernization.webp',
  alt: 'モダナイゼーション',
}

const ProblemList = {
  titleProblem: 'DX推進を進める上での課題',
  problem1: '2025年のDX推進においては、レガシーシステムの肥大化がビジネス変革の足かせに',
  problem2: 'ドキュメントが古くブラックボックス化されたシステム',
  problem3: '技術者の高齢化や退職により、システムに関するノウハウが失われる危機',
  problem4: '開発会社との契約終了や担当者の不在により、保守対応・改修の糸口が見えない状態',
  problem5: '',

  titleCanDo: 'Aitriaができること',
  CanDo1: '生成AIによるソースコード解析により、ドキュメントが散逸していても仕様を正確に把握できる',
  CanDo2: 'AIが設計書や仕様書を自動生成し、システム全体の構造を明確に可視化できる',
  CanDo3: 'AIエージェントを活用することで、改修箇所の特定から実装までを効率的に支援できる',
  CanDo4: 'E2Eテストによって変更の影響範囲を把握し、リスクを最小限に抑えた安全なリリースを実現できる',
  CanDo5: '',
}

const featureList2: FeatureItem2 = {
  sectionRead: 'モダンテクノロジーとプラットフォーム構築で、お客様の開発内製化を包括的に支援します',
  featureArray: [
    {
      imgSrc: '/img/services/icon_agi.svg',
      title: '最先端の生成AIのフル活用',
      text: '大規模言語モデル（LLM）を活用したソースコードならびにドキュメントの解析。新たに既存システムの設計書、各種ドキュメントを生成し仕様把握を高速化します。',
    },
    {
      imgSrc: '/img/services/icon_hand.svg',
      title: 'E2Eテストの重視',
      text: '自動化ツールを活用した総合テストで改修後の動作を保証。リリース後のトラブルを未然に防止します。',
    },
    {
      imgSrc: '/img/services/icon_innovative.svg',
      title: '柔軟性とスピード',
      text: '大手ベンダーにありがちな煩雑なプロセスに捉われず、小回りの利くサポート。最新クラウド技術やコンテナ化なども柔軟に取り入れます。',
    },
    {
      imgSrc: '/img/services/icon_cloud.svg',
      title: 'クラウド移行支援',
      text: 'オンプレのシステムをクラウドリフト & シフトをサポート。可用性とセキュリティを考慮しながらもコストダウンを実現します。',
    },
    {
      imgSrc: '/img/services/icon_shake.svg',
      title: '保守・運用も継続サポート',
      text: '改修後の運用監視、オブザーバビリティの実施や追加開発の対応。担当者不在の企業でも長期的に安心して利用できる体制を整えています。',
    },
  ],
}

const stepIconList: StepModernizationItem = {
  sectionTitle: '導入ステップ',
  sectionRead: '現行システムの負荷やリスクに応じて柔軟にステップを進められます。いずれかの段階からの導入も可能です',
  stepIcon: [
    {
      no: '01.',
      icon: '/img/services/modernization_step01.svg',
      title: 'ドキュメントの整備',
      text: '生成AIでソースコード・既存資料を解析し、設計書・仕様書を再構築。システム全体の構造が把握できる状態を目指します。',
    },
    {
      no: '02.',
      icon: '/img/services/modernization_step02.svg',
      title: '既存システムの改修',
      text: 'AIエージェントがバグ修正や機能追加箇所を抽出。エンジニアがレビューを行い、E2Eテストで安全性を確認します。',
    },
    {
      no: '03.',
      icon: '/img/services/modernization_step03.svg',
      title: 'クラウドリフト／シフト',
      text: 'インフラをクラウドに移行し、スケーラビリティとコスト最適化を図る。必要に応じてコンテナ化やCI/CDの導入をサポートします。',
    },
    {
      no: '04.',
      icon: '/img/services/modernization_step04.svg',
      title: '新アーキテクチャへの刷新',
      text: 'マイクロサービス化、サーバーレス化などモダン設計を採用。アプリケーション構造自体を段階的に再構築し、保守性・拡張性を高めます。',
    },
    {
      no: '05.',
      icon: '/img/services/modernization_step05.svg',
      title: '新システムへの移行',
      text: '必要に応じ、全面的に新しい技術基盤へ置き換え。既存データ移行、ユーザー影響最小化策を実施しながらスムーズに切り替えます。',
    },
  ],
}

const relatedPostsList: RelatedPostsItem = {
  sectionTitle: 'モダナイゼーションの関連記事',
  relatedPosts: [
    {
      title: 'AI導入が進まないのはなぜ？自社に最適なモダナイゼーション戦略とは【ロードマップ&チェックシート付き】',
      link: 'https://aitria.co.jp/in-pocket/modernization-strategy/',
      thumbnail:
        'https://aitria.co.jp/in-pocket/wp-content/uploads/2025/10/%E3%81%A8%E3%81%AF%EF%BC%9F-2400-x-1600-px-3.png',
      day: '2025年10月3日',
      category: 'AI',
    },
    {
      title: 'モダナイゼーションとは？レガシーマイグレーションとの違いや具体的な手法、進め方を解説',
      link: 'https://aitria.co.jp/in-pocket/what-is-modernization/',
      thumbnail: 'https://aitria.co.jp/in-pocket/wp-content/uploads/2025/02/modernization.png',
      day: '2025年10月9日',
      category: '開発・エンジニアリング',
    },
    {
      title: 'AIエージェント時代の到来 – ビジネスリーダーが今から準備すべきこと',
      link: 'https://aitria.co.jp/in-pocket/ai-agent-1/',
      thumbnail: 'https://aitria.co.jp/in-pocket/wp-content/uploads/2025/04/ai-agent.png',
      day: '2025年4月24日',
      category: 'AI',
    },
    {
      title: '【初心者向け】クラウドリフト実践！計画から移行、運用まで徹底解説',
      link: 'https://aitria.co.jp/in-pocket/cloud-lift/',
      thumbnail: 'https://aitria.co.jp/in-pocket/wp-content/uploads/2025/03/CloudLift.png',
      day: '2025年9月28日',
      category: '開発・エンジニアリング',
    },
  ],
}

const Modernization: React.FC = () => {
  return (
    <>
      <div className={styles.space}>
        <ServicesFV ServicesFVEach={ServicesFVList} paths={paths} />
        <Problem ProblemEach={ProblemList} />
      </div>
      <div className={styles.backGround}>
        <Feature2 FeatureEach2={[featureList2]} />
      </div>
      <StepIcon StepIconEach={[stepIconList]} />
      <div className={styles.backGround}>
        <Faq FaqEach={[modernizationFaqList]} />
      </div>
      <div className={styles.backGroundGray}>
        <RelatedPosts RelatedPostsEach={[relatedPostsList]} />
      </div>
      <FooterCTA />
    </>
  )
}

export default Modernization
